import { useContext } from 'react';
import GreatDealsLabel from '@/srp/FiltersMenu/GreatDeals/GreatDealsLabel';
import TagId from '~/constants/srp/TagId';
import AppliedFiltersContext from '~/context/srp/AppliedFiltersContext';
import { useFacetData } from '~/context/srp/FacetDataContext';
import { isDefined } from '~/utilities/srp/array';
import Checkbox from '../Checkbox';
import FilterDrawer from '../FilterDrawer';
import { CommonWrapper } from '../styles';
import useExpand from '../useExpand';
import type WithClassName from '../WithClassName';

export default function GreatDeals({ className }: WithClassName) {
  const [show, setShow] = useExpand(false);
  const { appliedFilters, updateListFilter, updateBooleanFilter } = useContext(
    AppliedFiltersContext
  );
  const facetData = useFacetData();

  const { tagIds, isFreeDelivery } = facetData.waysToSave ?? {};
  const filterKey = 'ways-to-save';

  const alphabetizedFilters = [
    isFreeDelivery,
    ...(tagIds?.buckets ?? [])
  ].filter(isDefined);

  return (
    <FilterDrawer
      className={className}
      dataQa={`facet-${filterKey}`}
      facetContent={tagIds}
      facetName="Great Deals"
      show={show}
      onToggle={() => {
        setShow(!show);
      }}
    >
      <CommonWrapper>
        {alphabetizedFilters.map(({ displayName = '', key }) => {
          return key === 'isFreeDelivery' ? (
            <Checkbox
              key={key}
              checked={appliedFilters.isFreeDelivery ?? false}
              facet={filterKey}
              filter={key}
              id={`${filterKey}-isFreeDelivery`}
              label={
                <GreatDealsLabel displayName={displayName} labelKey={key} />
              }
              onChange={() => {
                updateBooleanFilter({
                  filterKey: 'isFreeDelivery',
                  value: !appliedFilters?.isFreeDelivery
                });
              }}
              className="!items-start"
            />
          ) : (
            <Checkbox
              key={displayName}
              checked={appliedFilters?.tagIds?.includes(key)}
              id={`${filterKey}-${displayName}`}
              facet={filterKey}
              filter={key}
              label={
                <GreatDealsLabel
                  displayName={
                    key === TagId.EVCredit.toString()
                      ? 'EV Tax Credit'
                      : displayName
                  }
                  labelKey={key}
                />
              }
              onChange={() =>
                updateListFilter({
                  filterKey: 'tagIds',
                  value: key
                })
              }
              className="!items-start"
            />
          );
        })}
      </CommonWrapper>
    </FilterDrawer>
  );
}
